{
	"backToStartPage": "Tillbaka till startsidan",
	"transactionDetailsTitle": "Transaktionsdetaljer",
	"btnVerifyTransactions": "Verifiera transaktioner",
	"kpi": {
		"date": "Datum",
		"quantity": "Kvantitet",
		"carbonReductions": "Koldioxidreduktioner"
	},
	"verifyTransactionModal": {
		"title": "Verifiera transaktion",
		"description": "Ange Record ID för denna transaktion. Du hittar informationen på deklarationen.",
		"recordIdLabel": "Record ID",
		"cancelTitle": "Avbryt",
		"verifyTitle": "Verifiera",
		"errors": {
			"recordIdRequired": "Record ID krävs",
			"recordIdInvalid": "Record ID must be 16 characters (letters or numbers), formatted like ABCD 1234 EFGH 5678",
			"verificationFailed": "Transaktionen kunde inte verifieras. Kontrollera Record ID"
		}
	},
	"errors": {
		"notFound": "Transaktionen hittades inte"
	}
}
